module.exports = __webpack_public_path__ + "../resources/img/bg_pictogram.84671a78.png";